var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h2", [_vm._v("Settings")])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-tabs",
                    { attrs: { "content-class": "mt-3" } },
                    [
                      _c(
                        "b-tab",
                        { attrs: { title: "IP Blacklist" } },
                        [_c("ip-blacklist", { attrs: { id: "ip-blacklist" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        { attrs: { title: "Properties" } },
                        [
                          _c("properties", {
                            attrs: { id: "configurable-properties" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        { attrs: { title: "Tools" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-3",
                              attrs: { variant: "warning" },
                              on: { click: _vm.publishAllConfigurations }
                            },
                            [
                              _c("i", { staticClass: "fa fa-share-square" }),
                              _vm._v(
                                " Publish All Configurations\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }